import styled from 'styled-components'
import { white, gray, grayDarker } from '@bufferapp/ui/style/colors'

import { baseFont } from '~/shared/styles/font'

/**
 *
 */

export const Input = styled.input`
  background: ${white};
  border: 1px solid ${gray};
  border-radius: 4px;
  width: 16px;
  height: 16px;
  cursor: pointer;
`

export const Label = styled.label`
  ${baseFont}
  font-weight: 500;
  color: ${grayDarker};
  margin: 0px 4px;
  cursor: pointer;
`
